/**
 * FABRIC const symbols.
 * @constant
 * @type {Object}
 */



const FABRIC = {
    EV_NAME: 'evName',
    START_WITH: 'fb_'
};


export {FABRIC};